ConnectStore = require 'components/enhancers/connect_store'
DocumentSectionsV2Actions = require 'actions/document_sections_v2_actions'
MdaHandoutExtraActions = require 'components/mda/handouts/mda_handout_extra_actions'
MdaTopicsActions = require 'actions/mda_topics_actions'
MiniDSActions = require 'actions/mini_ds_actions'
MiniDSStore = require 'stores/mini_ds_store'
MiniDocumentModal = require 'components/mini_ds/mini_document_modal'
DocumentProgressSelect = require 'components/mini_ds/document_progress_select'
{ MDA_HANDOUT } = require 'lib/db_docs/doc_types'
{ isCurrentUserAdmin } = require 'lib/members_helper'
{ Button } = ReactComponents
{ useCoffeeCallback, useI18n, useCoffeeMemo } = require 'lib/react_utils'

storeConnector =
  MiniDSStore: (Store) ->
    createOrEditDialogOpen: Store.isCreateOrEditDialogOpen()
    doc: Store.getDocument()

MiniDSToolbar = ({
  createOrEditDialogOpen
  currentDocumentId
  doc
  documentType
}) ->

  namespace = if documentType is MDA_HANDOUT then 'mda:handouts' else 'docsec:mini_ds'
  i18n = useI18n(namespace)
  openCreateOrEditDialog = useCoffeeCallback [], -> MiniDSActions.openCreateOrEditDialog()

  afterDocumentStatusChange = useCoffeeCallback [doc], ({ key, value }) ->
    if documentType is MDA_HANDOUT and value is 'excluded'
      topicId = doc.getIn(['options', 'parentTopicId'], null)
      return unless topicId
      excluded = value is 'excluded'
      MdaTopicsActions.toggleHandoutExclusionInTopic { topicId, excluded }

  <div className="flex flex-row mx-10 items-center">
    <h2 className="flex-grow">
      {if doc.get('name') then doc.get('name') else i18n('toolbar_title')}
    </h2>
    <div>
      <div className="flex flex-row items-center">
        {!_.isEmpty(currentDocumentId) and <Button
          className="mr-5"
          onClick={DocumentSectionsV2Actions.expandAllChapters}
          >
            {i18n '/actions.expand_all'}
          </Button>
        }
        {documentType is MDA_HANDOUT and not _.isEmpty(currentDocumentId) and
          <div className="flex flex-row items-center gap-5">
            <MdaHandoutExtraActions handoutId={currentDocumentId} />
            <DocumentProgressSelect
              afterStatusChange={afterDocumentStatusChange}
              documentId={currentDocumentId}
              documentType={documentType}
              editable={isCurrentUserAdmin()}
              showLabel={false}
              withCompleted={false}
            />
          </div>
        }
        {isCurrentUserAdmin() and _.isEmpty(currentDocumentId) and  <div className="flex flex-row">
          <Button
            className="btn btn-apply"
            label={i18n 'new_document'}
            onClick={openCreateOrEditDialog}
          />
        </div>}
        {createOrEditDialogOpen and <MiniDocumentModal documentType={documentType} />}
      </div>
    </div>
  </div>

MiniDSToolbar.propTypes =
  createOrEditDialogOpen: PropTypes.bool.isRequired
  currentDocumentId: PropTypes.string
  doc: PropTypes.instanceOf(Immutable.Map).isRequired
  documentType: PropTypes.oneOf([MDA_HANDOUT, 'mini_ds']).isRequired

module.exports = ConnectStore MiniDSToolbar,
  [MiniDSStore], storeConnector
